<div class="solo update-form-activity">
    <section class="child" c-workflow-blurb workflow="updateForm.workflow"></section>
</div>